var map = {
	"./audio-placeholder": 610,
	"./audio-placeholder.png": 610,
	"./avatar-missing": 540,
	"./avatar-missing.png": 540,
	"./avatar-missing.svg": 1036,
	"./halloween/clouds": 611,
	"./halloween/clouds.png": 611,
	"./halloween/halloween-emblem": 803,
	"./halloween/halloween-emblem.svg": 803,
	"./halloween/spider": 1006,
	"./halloween/spider.svg": 1006,
	"./halloween/spiderweb": 1007,
	"./halloween/spiderweb.svg": 1007,
	"./halloween/starfield": 1008,
	"./halloween/starfield.png": 1008,
	"./halloween/twinkle": 1009,
	"./halloween/twinkle.svg": 1009,
	"./header-missing": 548,
	"./header-missing.png": 548,
	"./soapbox-logo": 549,
	"./soapbox-logo-white": 550,
	"./soapbox-logo-white.svg": 550,
	"./soapbox-logo.svg": 549,
	"./sprite-post-functions": 1018,
	"./sprite-post-functions.png": 1018,
	"./video-placeholder": 1019,
	"./video-placeholder.png": 1019,
	"./void": 1020,
	"./void.png": 1020,
	"./web-push/web-push-icon_expand": 1021,
	"./web-push/web-push-icon_expand.png": 1021,
	"./web-push/web-push-icon_favourite": 1022,
	"./web-push/web-push-icon_favourite.png": 1022,
	"./web-push/web-push-icon_reblog": 1023,
	"./web-push/web-push-icon_reblog.png": 1023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1035;